import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";

const statusColor = (theme) => ({
  success: theme.palette.success.main,
  info: theme.palette.secondary.main,
  error: theme.palette.error.main,
  warning: theme.palette.warning.main,
});

const ColoredCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== "status",
})(({ status, theme }) => {
  const accent = statusColor(theme)[status] || theme.palette.grey[400];
  return {
    borderLeftColor: accent,
    borderLeftWidth: "6px",
    borderLeftStyle: "solid",
  };
});

export default ColoredCard;
